import React from 'react'

export const IconVideo = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      id="video"
      viewBox="160.1 96.1 191.9 320"
      fill="currentColor"
      {...props}
    >
      <path d="M184.8 413.1l2.1-1.8 156.5-136c5.3-4.6 8.6-11.5 8.6-19.2 0-7.7-3.4-14.6-8.6-19.2L187.1 101.1l-2.6-2.3c-2.5-1.7-5.5-2.7-8.7-2.7-8.7 0-15.8 7.4-15.8 16.6v286.8c0 9.2 7.1 16.6 15.8 16.6 3.3 0 6.5-1.2 9-3z"></path>
    </svg>
  )
}
